<template>
  <v-app>

    <div v-if="$store.state.manager.module === $store.state.manager.settingsModule">
      <SettingsModule/>
    </div>
    <div v-else-if="$store.state.manager.module === $store.state.manager.displayModuleName">
       <DisplayModule />
    </div>
    <div v-else-if="$store.state.manager.module === $store.state.manager.bookModuleName ">
      <BookModule />
    </div>
    <div v-else-if="$store.state.manager.module === 'core'" >
      <CoreModule />
    </div>

    <!-- Main Route Window, is not given in the different modules as its the same for every module anyway -->
    <v-main v-if="isLoggedIn || (!isLoggedIn && this.$route.meta.isPublic)">
      <router-view></router-view>
      <div class="my-15"/>
      <FooterComponent />
    </v-main>

    <!-- Cookie law information, should possibly be shown at any point in the app -->
    <cookie-law theme="blood-orange--rounded"
                :message="$t('utils:cookie.message')"
                :buttonText="$t('buttons:accept')"
    />

    <!-- Component for showing snackbar info, should possibly be shown at any point in the pap -->
    <SnackbarComponent />

    <GlobalOverlay />

    <PatchPopupWindow />

  </v-app>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import BookModule from '@/modules/book/BookModule';
import DisplayModule from '@/modules/display/DisplayModule';
import SettingsModule from '@/modules/settings/SettingsModule';
import FooterComponent from '@/modules/core/components/Footer/FooterComponent';
import SnackbarComponent from '@/modules/core/components/SnackbarComponent';
import CoreModule from '@/modules/core/CoreModule';
import Vue from 'vue';
import {mapActions, mapGetters} from 'vuex';
import GlobalOverlay from '@/modules/core/components/GlobalOverlay';
import PatchPopupWindow from '@/modules/core/views/PatchPopupWindow';
import UsersService from "@/modules/core/services/users-service";
import DataUtils from "@/modules/core/services/data-utils";
import Users from "@/modules/core/data/users";

export default {
  name: 'App',
  components: {
    PatchPopupWindow,
    GlobalOverlay,
    BookModule,
    DisplayModule,
    SettingsModule,
    FooterComponent,
    CookieLaw,
    SnackbarComponent,
    CoreModule
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapActions('auth', ['clearStore']),
  },
  beforeCreate() {
    if (!Vue.$keycloak.authenticated) {
      return;
    }
    UsersService.readProfileFromAPI(
        (resp) => {
          let response = DataUtils.parseDataToSingleObject(resp.data, Users);
          this.$store.commit("auth/storeProfile", response);
        }
    )
  },
  created() {
    //check if we have to clear old token-information
    // otherwise user is still considered logged-in with old token
    if (!Vue.$keycloak.authenticated) {
      this.$store.dispatch('auth/clearStore');
    }
  }
};
</script>
<style src="@/styles/app.scss" lang="scss"/>
